import { useEffect } from "react";

import {
  connectWONotesSocket,
  disconnectWONotesSocket,
} from "src/Services/socket/woNotesSocket";

const useWONotesRealtime = ({ woId, onAdminRefresh, onTechRefresh }) => {
  useEffect(() => {
    if (!woId) {
      return undefined;
    }

    const socket = connectWONotesSocket();
    const roomPayload = { woId };

    const joinRoom = () => {
      socket.emit("wo-notes:join", roomPayload);
    };

    const refreshAll = () => {
      onAdminRefresh?.();
      onTechRefresh?.();
    };

    const handleNoteChanged = (payload) => {
      if (
        Number(payload?.woId) !== Number(woId) ||
        document.visibilityState !== "visible"
      ) {
        return;
      }

      if (payload.noteType === "admin") {
        onAdminRefresh?.();
      }

      if (payload.noteType === "tech") {
        onTechRefresh?.();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") {
        return;
      }

      connectWONotesSocket();
      joinRoom();
      refreshAll();
    };

    socket.on("connect", joinRoom);
    socket.on("wo-note-changed", handleNoteChanged);

    if (socket.connected) {
      joinRoom();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      socket.off("connect", joinRoom);
      socket.off("wo-note-changed", handleNoteChanged);
      socket.emit("wo-notes:leave", roomPayload);
      disconnectWONotesSocket();
    };
  }, [woId, onAdminRefresh, onTechRefresh]);
};

export default useWONotesRealtime;
